export function openVKGroup(screenName: string, options: { isDesktop?: boolean } = {}) {
  const { isDesktop } = options;
  const link = document.createElement('a');
  link.setAttribute('href', `https://${isDesktop ? '' : 'm.'}vk.com/${screenName}`);
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
  link.click();
}
